import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiConfig } from '@employee-configs/api.config';
import { catchError } from 'rxjs/operators';
import * as EmployeeModels from '@employee-models/index';

@Injectable({
    providedIn: 'root'
})

export class DeliveryLocationService {

    private deliveryLocationsData: EmployeeModels.DM.IDeliveryLocationDto[] = [];

    constructor(private httpClient: HttpClient) { }

    fetchDeliveryLocations(): void {
        this.httpClient.get<EmployeeModels.DM.IDeliveryLocationDto[]>(ApiConfig.BadgeRequests.deliveryLocations)
            .pipe(
                catchError((error) => {
                    this.deliveryLocations = [];
                    return throwError(error);
                })
            ).subscribe(data => this.deliveryLocations = data);
    }

    get deliveryLocations(): EmployeeModels.DM.IDeliveryLocationDto[] {
        return this.deliveryLocationsData;
    }

    set deliveryLocations(value: EmployeeModels.DM.IDeliveryLocationDto[]) {
        this.deliveryLocationsData = value;
    }

}
